module.exports = __webpack_public_path__ + "img/no-audio.8eade51d.svg";